import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(ScrollTrigger, Draggable);

function scrollHorizontal() {

    // console.log('Scroll Horizontal block loaded');

    const scrollSections = document.querySelectorAll('.scroll-horizontal .block__wrapper, .scroll_horizontal_02 .block__wrapper');

    scrollSections.forEach(wrapper => {
        
        const container = wrapper.querySelector('.scroll-horizontal__container');
        if (!container) return;

        // Solo activar scroll horizontal en desktop (> 992px)
        const mm = gsap.matchMedia();

        mm.add("(min-width: 992px)", () => {
            // Calcular el ancho total del scroll horizontal
            const scrollWidth = container.scrollWidth;
            const wrapperWidth = wrapper.offsetWidth;
            const wrapperStyles = getComputedStyle(wrapper);
            const paddingLeft = parseFloat(wrapperStyles.paddingLeft) || 0;
            const paddingRight = parseFloat(wrapperStyles.paddingRight) || 0;
            const totalPadding = paddingLeft + paddingRight;
            const scrollDistance = scrollWidth - wrapperWidth + totalPadding;

            // Crear animación de scroll horizontal con pin
            gsap.to(container, {
                x: -scrollDistance,
                ease: 'none',
                scrollTrigger: {
                    trigger: wrapper,
                    start: 'top top',
                    end: () => `+=${scrollDistance}`,
                    pin: true,
                    scrub: 1,
                    invalidateOnRefresh: true,
                }
            });
        });
    });

    // Inicializar Before/After Splitters
    initBeforeAfterSplitter();

}

function initBeforeAfterSplitter() {

    const splitters = document.querySelectorAll('[data-splitter="wrap"]');

    const setupSplitter = (splitter) => {
        const handle = splitter.querySelector('[data-splitter="handle"]');
        const after = splitter.querySelector('[data-splitter="after"]');

        if (!handle || !after) return;

        let bounds = splitter.getBoundingClientRect();
        let currentPercent = parseFloat(splitter.getAttribute('data-splitter-initial')) || 50;

        const setPositions = (percent) => {
            bounds = splitter.getBoundingClientRect();
            const positionX = (percent / 100) * bounds.width;
            gsap.set(handle, { x: positionX, left: 'unset' });
            gsap.set(after, { clipPath: `inset(0 0 0 ${percent}%)` });
        };

        setPositions(currentPercent);

        Draggable.create(handle, {
            type: 'x',
            bounds: splitter,
            cursor: 'ew-resize',
            activeCursor: 'grabbing',
            onDrag() {
                currentPercent = (this.x / bounds.width) * 100;
                gsap.set(after, { clipPath: `inset(0 0 0 ${currentPercent}%)` });
            }
        });

        window.addEventListener('resize', () => setPositions(currentPercent));
    };

    splitters.forEach(setupSplitter);
    
}

export default scrollHorizontal;